var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image",class:[
    ("image--" + _vm.align),
    {
      'image--show': _vm.loaded,
      'image--logo': parseInt(_vm.width) === 10,
      'image--20': parseInt(_vm.width) === 20,
      'image--25': parseInt(_vm.width) === 25,
      'image--33': parseInt(_vm.width) === 33,
      'image--50': parseInt(_vm.width) === 50,
      'image--75': parseInt(_vm.width) === 75,
      'image--100': parseInt(_vm.width) === 100,
      'image--full-bleed': parseInt(_vm.width) < 1,
      'image--landscape': _vm.image.width > _vm.image.height,
      'image--portrait': _vm.image.height >= _vm.image.width,
      'image--highlight': _vm.includeHighlight,
      'image--caption': _vm.caption
    }
  ]},[_c('img',{ref:"image",staticClass:"img",style:(("max-height: " + _vm.imageStyle)),attrs:{"src":_vm.image.url},on:{"click":function($event){return _vm.highlight()}}}),_c('p',{staticClass:"note",domProps:{"innerHTML":_vm._s(_vm.caption)}})])}
var staticRenderFns = []

export { render, staticRenderFns }